/**
 * Assignment-execution-delay lifecycle statuses.
 * Source of truth — keep in sync with sara node [[WORKFLOW-DELAY-LIFECYCLE]].
 *
 * Lives in Ship/ because the same map is consumed by RequestContainer (domain)
 * AND by the cross-cutting dashboard in HomeContainer. RequestContainer's own
 * Contracts/DelayStatus.ts is now a thin re-export of this module.
 */
export type DelayStatus = 'received' | 'escalated' | 'resolved' | 'not_resolved'

export const DELAY_STATUS_MAP: Record<DelayStatus, { label: string; color: string }> = {
    received: { label: 'Отримано', color: 'orange' },
    escalated: { label: 'Ескальовано', color: 'red' },
    resolved: { label: 'Вирішено', color: 'green' },
    not_resolved: { label: 'Не вирішено', color: 'volcano' },
}
